var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('PageTitle',{attrs:{"title":"404 Page Not Found"}}),_c('h1',[_vm._v("Yikes!")]),_c('h1',[_vm._v("Page Not Found!")]),_c('h1',[_c('router-link',{attrs:{"to":"/"}},[_vm._v("Home")])],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }